export const AUTHENTICATION_STORAGE_KEY = 'authToken';
